import { IApiResponse } from "clients/AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetMyWorkersRequestSchema,
  TGetMyWorkersResponseSchema,
} from "./getMyWorkers.schema";

export const getMyWorkers = (axios: IAxiosInstance) => {
  return async (params: TGetMyWorkersRequestSchema) => {
    const { query, ...rest } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TGetMyWorkersResponseSchema>
    >(`/api/getMyWorkers`, {
      params: { ...query, ...rest },
    });
    return response.data;
  };
};
